// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Supabase Light Theme (OKLCH) */
  --background: oklch(0.9911 0 0);
  --foreground: oklch(0.2046 0 0);
  --card: oklch(0.9911 0 0);
  --card-foreground: oklch(0.2046 0 0);
  --popover: oklch(0.9911 0 0);
  --popover-foreground: oklch(0.4386 0 0);
  --primary: oklch(0.8348 0.1302 160.9080);
  --primary-foreground: oklch(0.2626 0.0147 166.4589);
  --secondary: oklch(0.9940 0 0);
  --secondary-foreground: oklch(0.2046 0 0);
  --muted: oklch(0.9461 0 0);
  --muted-foreground: oklch(0.2435 0 0);
  --accent: oklch(0.9461 0 0);
  --accent-foreground: oklch(0.2435 0 0);
  --destructive: oklch(0.5523 0.1927 32.7272);
  --border: oklch(0.9037 0 0);
  --input: oklch(0.9731 0 0);
  --ring: oklch(0.8348 0.1302 160.9080);
  --radius: 0.5rem;
}

[data-theme='dark'] {
  /* Supabase Dark Theme (OKLCH) */
  --background: oklch(0.1822 0 0);
  --foreground: oklch(0.9288 0.0126 255.5078);
  --card: oklch(0.2046 0 0);
  --card-foreground: oklch(0.9288 0.0126 255.5078);
  --popover: oklch(0.2603 0 0);
  --popover-foreground: oklch(0.7348 0 0);
  --primary: oklch(0.4365 0.1044 156.7556);
  --primary-foreground: oklch(0.9213 0.0135 167.1556);
  --secondary: oklch(0.2603 0 0);
  --secondary-foreground: oklch(0.9851 0 0);
  --muted: oklch(0.2393 0 0);
  --muted-foreground: oklch(0.7122 0 0);
  --accent: oklch(0.3132 0 0);
  --accent-foreground: oklch(0.9851 0 0);
  --destructive: oklch(0.3123 0.0852 29.7877);
  --border: oklch(0.2809 0 0);
  --input: oklch(0.2603 0 0);
  --ring: oklch(0.8003 0.1821 151.7110);
}

* {
  font-family: 'Outfit', sans-serif !important;
}

body {
  margin: 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--background);
  color: var(--foreground);
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--muted-foreground);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;EAC5B,uCAAuC;EACvC,wCAAwC;EACxC,mDAAmD;EACnD,8BAA8B;EAC9B,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;EACtC,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,2CAA2C;EAC3C,yBAAyB;EACzB,gDAAgD;EAChD,4BAA4B;EAC5B,uCAAuC;EACvC,wCAAwC;EACxC,mDAAmD;EACnD,8BAA8B;EAC9B,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;EACtC,2CAA2C;EAC3C,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[":root {\n  /* Supabase Light Theme (OKLCH) */\n  --background: oklch(0.9911 0 0);\n  --foreground: oklch(0.2046 0 0);\n  --card: oklch(0.9911 0 0);\n  --card-foreground: oklch(0.2046 0 0);\n  --popover: oklch(0.9911 0 0);\n  --popover-foreground: oklch(0.4386 0 0);\n  --primary: oklch(0.8348 0.1302 160.9080);\n  --primary-foreground: oklch(0.2626 0.0147 166.4589);\n  --secondary: oklch(0.9940 0 0);\n  --secondary-foreground: oklch(0.2046 0 0);\n  --muted: oklch(0.9461 0 0);\n  --muted-foreground: oklch(0.2435 0 0);\n  --accent: oklch(0.9461 0 0);\n  --accent-foreground: oklch(0.2435 0 0);\n  --destructive: oklch(0.5523 0.1927 32.7272);\n  --border: oklch(0.9037 0 0);\n  --input: oklch(0.9731 0 0);\n  --ring: oklch(0.8348 0.1302 160.9080);\n  --radius: 0.5rem;\n}\n\n[data-theme='dark'] {\n  /* Supabase Dark Theme (OKLCH) */\n  --background: oklch(0.1822 0 0);\n  --foreground: oklch(0.9288 0.0126 255.5078);\n  --card: oklch(0.2046 0 0);\n  --card-foreground: oklch(0.9288 0.0126 255.5078);\n  --popover: oklch(0.2603 0 0);\n  --popover-foreground: oklch(0.7348 0 0);\n  --primary: oklch(0.4365 0.1044 156.7556);\n  --primary-foreground: oklch(0.9213 0.0135 167.1556);\n  --secondary: oklch(0.2603 0 0);\n  --secondary-foreground: oklch(0.9851 0 0);\n  --muted: oklch(0.2393 0 0);\n  --muted-foreground: oklch(0.7122 0 0);\n  --accent: oklch(0.3132 0 0);\n  --accent-foreground: oklch(0.9851 0 0);\n  --destructive: oklch(0.3123 0.0852 29.7877);\n  --border: oklch(0.2809 0 0);\n  --input: oklch(0.2603 0 0);\n  --ring: oklch(0.8003 0.1821 151.7110);\n}\n\n* {\n  font-family: 'Outfit', sans-serif !important;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--background);\n  color: var(--foreground);\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--muted-foreground);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
